'use strict';

angular.module('TurneroApp').component('coReagendarTurno', {
	bindings: {
		ctrlPadre: '=',
		turno: '<',
		idMotivoReagendar: '<'
	},
	controller: [
		 'turnosService',
		 'utilsService',
		 'TurneroAppConstant',
		 '$mdDialog',
		 'agendaService',
		 function (turnosService, utilsService, TurneroAppConstant, $mdDialog, agendaService) {
		 	var ctrl = this;
		 	ctrl.Estados = TurneroAppConstant.Estados.Turno;

		 	ctrl.limpiarVariables = function () {
		 		ctrl.error = {};
		 	};

		 	ctrl.$onChanges = function () {
		 		if (ctrl.turno && ctrl.idMotivoReagendar) {
		 			ctrl.turno.Turno_Fecha = moment(ctrl.turno.Turno).toDate();
		 			ctrl.turno.Agenda = {
		 				id: ctrl.turno.Id_Agenda,
		 				text: ctrl.turno.N_Agenda
		 			}
		 			ctrl.turno.Tramite = {
		 				id: ctrl.turno.Id_Tramite_Relevado,
		 				text: ctrl.turno.tramite
		 			}
		 		}
		 	}


		 	ctrl.confirmarReagendado = function (fecha_data) {


		 		var Turno = {
		 			//Fec_Turno_string: (fecha_data.dia.getDate().toString() + '/' + (fecha_data.dia.getMonth() + 1).toString() + '/' + fecha_data.dia.getFullYear().toString() + ' ' + fecha_data.hora),
                    //Enviamos en formato simil JSON/ISO8601 para que sea parseado en el backend con cualquier configuración regional y con la hora local al server
                    Fec_Turno: fecha_data.dia.getFullYear() + '-' + (fecha_data.dia.getMonth() + 1).toString() + '-' + fecha_data.dia.getDate() + 'T' + fecha_data.hora,
                    Id_Turno: ctrl.turno.Id_Turno,
                    Id_Motivo: ctrl.idMotivoReagendar
		 		};
		 		//var mensaje = 'El turno <strong>' + Turno.Id_Turno +'</strong> se ha reagendado correctamente.';
		 		utilsService.swalNotification('Un momento...', 'Se está reagendando el turno...', 'info');
		 	    //turnosService.Reagendar_Turno_Simple({ 'Id_Turno': Turno.Id_Turno, 'Id_Motivo': Turno.Id_Motivo, 'Fec_Turno_string': Turno.Fec_Turno_string }).$promise.then(function () {
                  turnosService.Reagendar_Turno_Simple({ 'Id_Turno': Turno.Id_Turno, 'Id_Motivo': Turno.Id_Motivo, 'Fec_Turno': Turno.Fec_Turno }).$promise.then(function () {
		 	        var id_reagendado = 0;
		 	        turnosService.Get_Id_Turno_Reagendado({ 'Id_Turno': Turno.Id_Turno}).$promise.then(function (data) {
		 	            id_reagendado = data.Data;
		 	            var mensaje = 'El turno <strong>' + id_reagendado + '</strong> se ha reagendado correctamente.';
		 	            swal({
		 	                title: 'Reagendado con éxito',
		 	                html: mensaje,
		 	                type: 'success',
		 	                allowEscapeKey: false,
		 	                allowOutsideClick: false
		 	            }).then(function () {
		 	                ctrl.ocultarCalendario(false);
		 	            }).catch(function () {
		 	                ctrl.ocultarCalendario(false);
		 	            });
		 	        }).catch(function (error) {
		 	            swal.close();
		 	            utilsService.errores(error);
		 	        });
		 	        
		 		}).catch(function (error) {
		 			swal.close();
		 			utilsService.errores(error);
		 		});
		 	}

		 	ctrl.ocultarCalendario = function (bool) {
		 		ctrl.ctrlPadre.turnoDetalles = false;
		 		ctrl.ctrlPadre.turnoReagendar = bool;
		 		ctrl.ctrlPadre.turnosConsulta = !bool;
		 		//se recarga la grilla, llamando al ctrl que es hijo del componente padre (ctrlTurnosListado es el componente: turnosComponent.js)
		 		ctrl.ctrlPadre.ctrlTurnosListado.grillaReload();
		 	}

		 }
	],
	template: require('./reagendarTurno.html')
});


// WEBPACK FOOTER //
// ./app/components/supervision/reagendarTurnoComponent.js